import { RouteComponentProps, Router } from "@reach/router";
import { APExpanded } from "ap-components";
import React from "react";

import ClientOnboardingPage from "./ClientOnboardingPage";
import OnboardingFailurePage from "./ClientOnboardingFailurePage";

export default function FDPage(props: RouteComponentProps) {
  return (
    <APExpanded>
      <Router style={{ height: "100%", display: "flex" }}>
        <ClientOnboardingPage path="/" default />
      </Router>
    </APExpanded>
  );
}
